function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.0666 19.9503C20.4576 18.123 22 15.2416 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.2416 3.54242 18.123 5.93339 19.9503L4.05663 23H6.40499L7.63578 21C8.95457 21.6406 10.4353 22 12 22C13.5647 22 15.0454 21.6406 16.3642 21L17.595 23H19.9434L18.0666 19.9503ZM15.3092 19.2856C14.3007 19.7444 13.1802 20 12 20C10.8198 20 9.69927 19.7444 8.69076 19.2856L12 13.9081L15.3092 19.2856ZM17.0117 18.236L12 10.092L6.98833 18.236C5.16609 16.7697 4 14.521 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.521 18.8339 16.7696 17.0117 18.236Z",
  fill: "black"
});

var SvgIcCategoryFerrisWheel = function SvgIcCategoryFerrisWheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCategoryFerrisWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_category_ferris_wheel.f74824be.svg";
export { ForwardRef as ReactComponent };